export default __webpack_public_path__ + "static/media/buildingBeartaria.4ac583f7.png";